let scrollTop = 0

export const lockBodyScroll = () => {
  if (typeof window === "undefined" || typeof document === "undefined") return
  const doc = document.documentElement
  scrollTop = window.scrollY || doc.scrollTop
  document.body.style.position = "fixed"
  document.body.style.top = `-${scrollTop}px`
  document.body.style.left = "0"
  document.body.style.right = "0"
  document.body.style.width = "100%"
}

export const unlockBodyScroll = () => {
  if (typeof window === "undefined" || typeof document === "undefined") return
  document.body.style.position = ""
  document.body.style.top = ""
  document.body.style.left = ""
  document.body.style.right = ""
  document.body.style.width = ""
  window.scrollTo(0, scrollTop)
}
